import classNames from 'classnames';
import { asText, Content, isFilled } from '@prismicio/client';

import {
  Box,
  Card,
  Heading,
  AutoGrid,
  CardFooter,
  CardHeader,
  Typography,
  CardContent,
} from '@preventx/oxygen';

// Components
import { Link } from '@/components/Actions/Link';
import { RichTextSimpleFeatures } from '@/components/RichText/RichTextSimpleFeatures';

type WithSimpleFeaturesProps = {
  sliceId: string;
  slice: Content.RegionSliceWithSimpleFeatures;
};

export const WithSimpleFeatures = ({
  sliceId,
  slice,
}: WithSimpleFeaturesProps) => {
  const { primary } = slice;
  const { title, caption, features, hide_title } = primary;

  return (
    <>
      <Box
        component="div"
        className="headline align-center"
        addSROnly={!isFilled.richText(title)}
      >
        <Box component="div" addFlow>
          <Heading component="h2" addHeadlineTitle addSROnly={hide_title}>
            {asText(title)}
          </Heading>

          {isFilled.richText(caption) && (
            <Typography component="p" className="headline__sub">
              {asText(caption)}
            </Typography>
          )}
        </Box>
      </Box>

      <AutoGrid component="div" placement="auto-fit">
        {(features ?? []).map((feature, index) => (
          <Card
            component="article"
            key={`region-simple-feature-${sliceId}-${index + 1}`}
          >
            <CardHeader addSROnly={feature.is_title_hidden}>
              <Heading component="h3">{asText(feature.title)}</Heading>
            </CardHeader>

            <CardContent addFlow>
              <RichTextSimpleFeatures content={feature.content} />
            </CardContent>

            {isFilled.link(feature.link) && (
              <CardFooter>
                <Link
                  as="default"
                  type="button"
                  retainSearchParams
                  href={feature.link}
                  className="card__action"
                >
                  {feature.link.text}
                </Link>
              </CardFooter>
            )}
          </Card>
        ))}
      </AutoGrid>
    </>
  );
};
